<template>
  <v-card class="rounded-lg flex d-flex flex-column">
    <v-card-text>
      <v-container fluid>
        <v-row class="fill-height">
          <v-col>
            <v-sheet height="64">
              <v-toolbar flat>
                <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                  Hoy
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="prev">
                  <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="next">
                  <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>Día</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Semana</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Mes</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                      <v-list-item-title>4 días</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="calc(100vh - (350px))">
              <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :event-color="getEventColor"
                :type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange"
                locale="es"></v-calendar>
              <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                <v-card color="grey lighten-4" min-width="350px" flat>
                  <v-toolbar :color="selectedEvent.color" dark>
                    <!-- <v-icon color="primary" v-if="selectedEvent.isUrgent"
                      >mdi-start</v-icon
                    > -->

                    <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="yellow" icon v-if="selectedEvent.isUrgent">
                      <v-icon>mdi-star</v-icon>
                    </v-btn>
                    <!-- <v-btn icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn> -->
                  </v-toolbar>
                  <v-card-text>
                    <span v-html="selectedEvent.details"></span>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text color="secondary" @click="selectedOpen = false">
                      Cerrar
                    </v-btn>
                    <v-btn text color="primary" @click="handleCalendarSelection(selectedEvent)">
                      Ver en tabla
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//Libraries
import dayjs from "dayjs";
export default {
  data: () => ({
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Mes",
      week: "Semana",
      day: "Día",
      "4day": "4 Días",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      // "indigo",
      // "deep-purple",
      // "cyan",
      // "green",
      // "orange",
      // "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    currentStart: null,
    currentEnd: null,
  }),
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    ...mapActions("order", ["getDeliveryByDateRange"]),
    ...mapMutations("order", ["SET_CALENDAR_SELECTION", "SET_CALENDAR_NEW_EVENT"]),
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async updateRange({ start, end }) {
      const events = [];
      this.currentStart = start
      this.currentEnd = end
      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      try {
        let response = await this.getDeliveryByDateRange({
          start: start.date,
          end: end.date,
        });

        for (let event of response.deliveries) {
          events.push({
            name: `Entrega de OP ${event.serial}`,
            start: event.deliveryProductionDate,
            end: event.deliveryProductionDate,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: true,
            isUrgent: event.isUrgent != undefined ? event.isUrgent : false,
            order: event.order,
            delivery: event._id
          });
        }
        // console.log(events);
        this.events = events;
      } catch (error) {
        console.log(error);
      }

      // for (let i = 0; i < eventCount; i++) {
      //   const allDay = this.rnd(0, 3) === 0;
      //   const firstTimestamp = this.rnd(min.getTime(), max.getTime());
      //   const first = new Date(firstTimestamp - (firstTimestamp % 900000));
      //   const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
      //   const second = new Date(first.getTime() + secondTimestamp);

      //   events.push({
      //     name: this.names[this.rnd(0, this.names.length - 1)],
      //     start: first,
      //     end: second,
      //     color: this.colors[this.rnd(0, this.colors.length - 1)],
      //     timed: !allDay,
      //   });
      // }
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("YYYY-MM-DD")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    handleCalendarSelection(order) {
      this.selectedOpen = null
      this.SET_CALENDAR_SELECTION(order)
    },
    async getEvents() {
      const events = [];

      const min = new Date(`${this.currentStart.date}T00:00:00`);
      const max = new Date(`${this.currentEnd.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      try {
        let response = await this.getDeliveryByDateRange({
          start: this.currentStart.date,
          end: this.currentEnd.date,
        });

        for (let event of response.deliveries) {
          events.push({
            name: `Entrega de OP ${event.serial}`,
            start: event.deliveryProductionDate,
            end: event.deliveryProductionDate,
            color: this.colors[this.rnd(0, this.colors.length - 1)],
            timed: true,
            isUrgent: event.isUrgent != undefined ? event.isUrgent : false,
            order: event.order,
            delivery: event._id
          });
        }
        // console.log(events);
        this.events = events;
      } catch (error) {
        console.log(error);
      }

    }
  },
  computed: {
    ...mapState("order", ["ordersEvents", "newEventCalendar"]),
  },
  watch: {
    ordersEvents: {
      handler() {
        this.events = [];
        if (this.ordersEvents.length == 1) {
          for (let item of this.ordersEvents) {
            this.focus = this.dateFormatShort(item.createdAt);
            this.events.push({
              name: item.serial + " " + item.client,
              start: this.dateFormatShort(item.createdAt),
              end: this.dateFormatShort(item.deliveryDate),
              color: "green",
              timed: true,
            });
          }
        } else {
          for (let item of this.ordersEvents) {
            this.events.push({
              name: item.serial + " " + item.client,
              start: this.dateFormatShort(item.createdAt),
              end: this.dateFormatShort(item.deliveryDate),
              color: "green",
              timed: true,
            });
          }
        }
      },
      deep: true,
    },
    async newEventCalendar() {
      if (!this.newEventCalendar) return
      await this.getEvents()
      this.SET_CALENDAR_NEW_EVENT(null)
    }
  },
};
</script>

<style scoped>
.production-order-detail {
  height: 500px;
  /* Ajusta la altura deseada */
}
</style>
